import availableIcons from './data/icons.json';
import legacyMapping from './data/legacy.json';

export class IconResolver {
  private static readonly ICON_PREFIX = 'icon-';

  /**
   * Get all available icons.
   *
   * @param prefixKeys Returns all options with keys prefixed with "icon-"
   */
  public options(prefixKeys: boolean = false): Record<string, string> {
    if (prefixKeys) {
      const mapped: Record<string, string> = {};

      for (const [key, value] of Object.entries(availableIcons)) {
        mapped[this.prefixKey(key)] = value;
      }

      return mapped;
    }

    return { ...availableIcons };
  }

  /**
   * Resolve the icon key, if it exists in the available icons.
   *
   * @param key The icon key to resolve
   * @param prefixed Resolve the icon name with "icon-" prefix
   */
  public resolve(key: string | null | undefined, prefixed: boolean = false): string | null {
    if (key == null) {
      return null;
    }

    const normalizedKey = this.normalize(key);

    if (!(normalizedKey in availableIcons)) {
      return null;
    }

    return prefixed ? this.prefixKey(normalizedKey) : normalizedKey;
  }

  /**
   * Prefix a normalized key with the "icon-" prefix.
   */
  private prefixKey(normalizedKey: string): string {
    return IconResolver.ICON_PREFIX + normalizedKey;
  }

  /**
   * Normalize the incoming key to an unprefixed version, apply necessary legacy mapping.
   *
   * @param key The key of the icon to normalize
   */
  private normalize(key: string): string {
    // Remove prefix
    if (key.startsWith(IconResolver.ICON_PREFIX)) {
      key = key.substring(IconResolver.ICON_PREFIX.length);
    }

    return legacyMapping[key as keyof typeof legacyMapping] ?? key;
  }
}
